/* Ambiente & Hogar — ajustes de toda la tienda. Ver ah-global.css */
(function(){
  /* El logo se pedia a 195px y un movil con densidad x3 necesita ~630:
     por eso se veia pixelado arriba y en el pie. */
  function logoNitido(){
    document.querySelectorAll('img').forEach(function(img){
      var s=img.getAttribute('src')||'';
      if(!/ambiente-hogar-(texto|logo|monograma)/.test(s)) return;
      if(img.dataset.ahNitido) return;
      var pic=img.closest('picture');
      if(pic) pic.querySelectorAll('source').forEach(function(so){ so.remove(); });
      var caja=img.getBoundingClientRect();
      var ancho=Math.round(Math.max(caja.width,210)*(window.devicePixelRatio||1)*1.15);
      if(ancho<420) ancho=420;
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.setAttribute('src', s.replace(/([?&])width=\d+/,'$1width='+ancho));
      img.dataset.ahNitido='1';
      if('MutationObserver' in window && !img.dataset.ahVigilado){
        img.dataset.ahVigilado='1';
        new MutationObserver(function(){
          var v=img.getAttribute('src')||'';
          var m=v.match(/width=(\d+)/);
          if(m && parseInt(m[1])<ancho){
            img.removeAttribute('srcset'); img.removeAttribute('sizes');
            img.setAttribute('src', v.replace(/([?&])width=\d+/,'$1width='+ancho));
          }
        }).observe(img,{attributes:true,attributeFilter:['src','srcset','sizes']});
      }
    });
  }
  /* CINTA DE RESENAS: desplazamiento continuo y lento en vez de saltos.
     Se duplican las tarjetas para que el bucle no tenga costura y se para
     mientras el dedo esta puesto. Aplica al home y a todas las paginas. */
  function cintaResenas(){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.testimonials-track').forEach(function(track){
      if(track.dataset.ahCinta) return;
      var originales=[].slice.call(track.children);
      if(originales.length<2) return;
      track.dataset.ahCinta='1';
      var ancho=Math.round(originales[0].getBoundingClientRect().width);
      if(!ancho) { delete track.dataset.ahCinta; return; }
      originales.forEach(function(t){ t.style.flex='0 0 '+ancho+'px'; t.style.width=ancho+'px'; t.style.maxWidth=ancho+'px'; });
      originales.forEach(function(t){ track.appendChild(t.cloneNode(true)); });
      var hueco=parseInt(getComputedStyle(track).gap)||20;
      var segundos=Math.max(90,Math.round(originales.length*(ancho+hueco)/15));
      track.style.width='max-content';
      track.style.transform='none';
      track.style.animation='ahCinta '+segundos+'s linear infinite';
      track.style.willChange='transform';
      var sec=track.closest('[id^="shopify-section"]')||track.parentElement;
      ['pointerdown','touchstart','mousedown'].forEach(function(ev){
        sec.addEventListener(ev,function(){ track.style.animationPlayState='paused'; },{passive:true}); });
      ['pointerup','pointercancel','touchend','touchcancel','mouseup','mouseleave'].forEach(function(ev){
        sec.addEventListener(ev,function(){ track.style.animationPlayState='running'; },{passive:true}); });
    });
  }

  /* Las imagenes pequenas se pedian mucho mas grandes de lo que se ven
     (avatares a 200 px para 40, miniaturas a 240 para 43). */
  function imagenesAjustadas(){
    document.querySelectorAll('.testimonials-section img, [class*="avatar"] img, [class*="thumbnail"] img').forEach(function(img){
      if(img.dataset.ahAjustada) return;
      var c=img.getBoundingClientRect();
      if(!c.width || c.width>200) return;
      var nec=Math.max(100, Math.ceil(c.width*(window.devicePixelRatio||1)));
      var s=img.getAttribute('src')||'';
      var m=s.match(/width=(\d+)/);
      if(m && parseInt(m[1]) > nec*1.4){
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.setAttribute('src', s.replace(/width=\d+/,'width='+nec));
        img.dataset.ahAjustada='1';
      }
    });
  }
  function ok(){ logoNitido(); imagenesAjustadas(); setTimeout(imagenesAjustadas,2000); cintaResenas(); setTimeout(cintaResenas,1500); setTimeout(logoNitido,1200); setTimeout(logoNitido,3000); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',ok); else ok();
  window.addEventListener('load',logoNitido);
})();

/* ── PDP Cabal · carrusel que corre solo, sin pelearse con el dedo (20-sep-2026) ── */
(function(){
  function arranca(carr){
    if(carr.dataset.autoTren) return; carr.dataset.autoTren='1';
    var VEL=0.30, ESPERA=2000;      // px por frame · ms de calma tras soltar
    var pausadoHasta=0, tocando=false, ultimo=null, yoMovi=0;
    function pausa(ms){ pausadoHasta=Math.max(pausadoHasta, Date.now()+(ms||ESPERA)); }
    function paso(t){
      if(ultimo==null) ultimo=t;
      var dt=Math.min(t-ultimo,50); ultimo=t;
      var libre=!tocando && Date.now()>pausadoHasta;
      if(libre && carr.scrollWidth>carr.clientWidth+4){
        var antes=carr.scrollLeft;
        var next=antes + VEL*(dt/16.7);
        if(next >= carr.scrollWidth-carr.clientWidth-1) next=0;
        yoMovi=next;                 // marca: este movimiento es mio
        carr.scrollLeft=next;
      }
      requestAnimationFrame(paso);
    }
    // el dedo o el raton mandan: mientras tocan, quieto
    ['pointerdown','touchstart','mousedown'].forEach(function(e){
      carr.addEventListener(e,function(){tocando=true;pausa();},{passive:true});});
    ['pointerup','pointercancel','touchend','touchcancel','mouseup'].forEach(function(e){
      carr.addEventListener(e,function(){tocando=false;pausa();},{passive:true});});
    carr.addEventListener('mouseenter',function(){pausa(600);},{passive:true});
    carr.addEventListener('mouseleave',function(){pausadoHasta=0;},{passive:true});
    // cualquier scroll que no sea el mio (inercia, rueda, teclado) tambien pausa
    carr.addEventListener('scroll',function(){
      if(Math.abs(carr.scrollLeft-yoMovi)>2) pausa();
    },{passive:true});
    carr.addEventListener('wheel',function(){pausa();},{passive:true});
    requestAnimationFrame(paso);
  }
  function init(){ document.querySelectorAll('[id$="__porque"] .k-carr').forEach(arranca); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();

/* ══ Identidad por producto en el pie y la cinta (20-sep-2026) ══
   Cada PDP con marca propia pone su logo, su frase y su garantia en el pie.
   Para anadir un producto: una linea mas en PDPS. Sin logo -> solo cambia el texto.
   21-sep: el logo y el (c) son de la TIENDA (monograma A&H) en todas; aqui solo frase y garantia. */
(function(){
  var PDPS = {
    'cabal-canela-de-ceilan': {
      garantia:90,
      texto:'Canela de Ceilán auténtica, medida, en una sola cápsula al día. Envío gratis a toda Colombia.'},
    'cloudsense-espuma-depilatoria': {
      texto:'Espuma depilatoria pensada para zonas delicadas y vello grueso. Envío gratis a toda Colombia.'},
    'rondin-repelente-de-roedores': {
      texto:'Repelente de roedores sin trampas, sin veneno y sin tener que recogerlos. Envío gratis a toda Colombia.'},
    'muack-pantuflas-besuconas': {
      texto:'Pantuflas para andar en casa, con esa cara que a todos les saca una sonrisa. Envío gratis a toda Colombia.'},
    'base-en-barra-con-serum': {
      texto:'Base en barra con hidratante: se difumina con los dedos y no se marca. Envío gratis a toda Colombia.'},
    'miamimd-advanced-crepe-fix': {
      texto:'Para la piel crepé de brazos y piernas, la que la crema normal no resuelve. Envío gratis a toda Colombia.'},
    'equipax-bolsa-de-viaje-con-bomba': {
      garantia:90,
      texto:'Bolsas de viaje al vacío con su bomba de bolsillo, para que tu ropa quepa en la pieza que pagaste. Envío gratis a toda Colombia.'}
  };
  var cfg=null;
  for (var h in PDPS){ if(location.pathname.indexOf(h)>-1){ cfg=PDPS[h]; break; } }
  if(!cfg) return;

  function textos(raiz){
    var it=document.createNodeIterator(raiz,NodeFilter.SHOW_TEXT,null),n;
    while((n=it.nextNode())){
      var v=n.nodeValue; if(!v) continue;
      if(cfg.garantia && v.indexOf('60 días')>-1)
        n.nodeValue=v.replace(/60 días/g, cfg.garantia+' días');
      if(cfg.marca && /©\s*\d{4}\s*Ambiente\s*&\s*Hogar/.test(n.nodeValue))
        n.nodeValue=n.nodeValue.replace(/Ambiente\s*&\s*Hogar/, cfg.marca);
      if(cfg.texto && n.nodeValue.indexOf('Cosas buenas para la casa')>-1)
        n.nodeValue=cfg.texto;
    }
  }
  function logoPie(){
    if(!cfg.logo) return;
    var pie=document.querySelector('footer') || document.querySelector('[id*="footer"]');
    if(!pie) return;
    pie.querySelectorAll('img').forEach(function(im){
      var src=(im.currentSrc||im.src||'');
      if(/ambiente-hogar-texto/i.test(src) && im.dataset.logoPdp!=='1'){
        im.dataset.logoPdp='1';
        im.removeAttribute('srcset'); im.removeAttribute('sizes');
        if(im.parentElement && im.parentElement.tagName==='PICTURE')
          im.parentElement.querySelectorAll('source').forEach(function(f){f.remove();});
        im.src='/cdn/shop/files/'+cfg.logo+'?width=420';
        im.alt=cfg.marca; im.style.maxWidth='185px'; im.style.width='auto'; im.style.height='auto';
      }
    });
  }
  function init(){
    textos(document.body); logoPie();
    var obs=new MutationObserver(function(){ textos(document.body); logoPie(); });
    obs.observe(document.body,{childList:true,subtree:true,characterData:true});
    setTimeout(function(){ obs.disconnect(); },9000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
